import React from "react";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import Table from "components/Table";
import FieldChooser from "components/FieldChooser";
import TopButtons from "components/TopButtons";
import { IQualityReport, IMeta, ICommonState } from "models/.";
import { columns } from "./columns";
import { connect } from "../../reduxConnector";
import QualityReportActions from "./actions";
import ReportsSearch from "./partials/ReportsSearch";
import { markAsRead, markAsUnread } from "../app/actions";
import { downloadDocuments } from "helpers/download";
import { getSelectedData } from "helpers/common";
import { CUSTOM_SETTINGS } from "constants/.";

interface IProps {
  getQualityReports: (meta?: IMeta) => void;
  reports: IQualityReport[];
  meta: IMeta;
  typeOptions: any[];
  getSelectOptions: () => void;
}

interface IState extends ICommonState {
  selectedData: any;
}

class QualityReport extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      selectedOption: "",
      showFieldChooser: false,
      columnsCopy: [],
      checkedRows: {},
      selectedData: []
    };
  }

  public componentDidMount() {
    const { typeOptions, getSelectOptions } = this.props;
    if (!typeOptions || !typeOptions.length) {
      getSelectOptions();
    }
  }

  public handleSelect = selectedOption => {
    const { checkedRows, selectedData } = this.state;
    const { value } = selectedOption;
    const ids = _(checkedRows)
      .keys()
      .map(_.toNumber)
      .value();

    value === "gelezen" && markAsRead(ids, "InspectionReport");
    value === "ongelezen" && markAsUnread(ids, "InspectionReport");
    if (value === "pdf") {
      const documentIds = _.compact(_.map(selectedData, "documentId"));
      downloadDocuments(documentIds, "INSPECTION_REPORT");
      markAsRead(ids, "InspectionReport");
    }
  };

  public handleFieldChooser = () => {
    this.setState(({ showFieldChooser }) => ({
      showFieldChooser: !showFieldChooser
    }));
  };

  public handleFieldsChange = data => {
    this.setState({ columnsCopy: data });
  };

  private onRowSelect = checkedRows => {
    this.setState({
      checkedRows,
      selectedData: getSelectedData(
        this.props.reports,
        checkedRows,
        this.state.selectedData
      )
    });
  };

  public render() {
    const { getQualityReports, reports, meta, typeOptions } = this.props;
    const {
      showFieldChooser,
      columnsCopy,
      selectedOption,
      checkedRows
    } = this.state;

    return (
      <div id="quality-report-page">
        <FormattedMessage id="INSPECTION_REPORT" tagName="h1" />
        <ReportsSearch
          meta={meta}
          onSearch={getQualityReports}
          typeOptions={typeOptions}
        />
        <TopButtons
          switchUnread={meta.unread}
          handleFieldChooser={this.handleFieldChooser}
          handleSelect={this.handleSelect}
          toggleUnread={() =>
            getQualityReports({
              ...meta,
              unread: !meta.unread,
              currentPage: 0
            })
          }
          selectedOption={selectedOption}
          entityName="quality-report"
        />
        <Table
          columns={columnsCopy}
          dataSource={reports}
          meta={meta}
          onQueryChange={getQualityReports}
          onRowSelect={this.onRowSelect}
          checkedRows={checkedRows}
          pageName={CUSTOM_SETTINGS.qualityReport}
        />
        <FieldChooser
          name="kbp_keurraporten"
          visible={showFieldChooser}
          handleFieldChooser={this.handleFieldChooser}
          handleFieldsChange={this.handleFieldsChange}
          columns={columns}
        />
      </div>
    );
  }
}

export default connect(
  state => ({
    reports: state.qualityReports.items,
    meta: state.qualityReports.meta,
    typeOptions: state.qualityReports.typeOptions
  }),
  {
    getQualityReports: QualityReportActions.getQualityReports,
    getSelectOptions: QualityReportActions.getSelectOptions
  }
)(QualityReport);
